// extracted by mini-css-extract-plugin
export var actionButton = "_wx-2";
export var card = "_wx-0";
export var disambiguationList = "_wx-3";
export var errorCard = "_wx-4";
export var row = "_wx-1";